import React, { useContext } from 'react';

import { UIContext } from 'context/ui';

import Icon from 'assets/svg/search.svg';

import s from './SearchButton.scss';

interface IProps {
  children?: React.ReactNode;
}

export const SearchButton = ({ children }: IProps) => {
  const { searchOpen, toggleSearch } = useContext(UIContext);

  return (
    <button className={s.searchButton} onClick={() => toggleSearch(!searchOpen)}>
      {children ?? 'Leita'}
      <Icon className={s.searchButton__icon} />
    </button>
  );
};
